export function initSkipLinks() {
  document.querySelectorAll('.skip-link').forEach(link => {
    link.addEventListener('click', () => {
      // Optionnel : masquer après clic pour nettoyer
      link.blur(); // Retire le focus
    });
  });
}